import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Radar, PenSquare, Settings2 } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { BulletinDashboard } from '../components/bulletins/BulletinDashboard';
import { ContentHub } from '../components/bulletins/ContentHub';
import { BulletinSettings } from '../components/bulletins/BulletinSettings';
import { bulletinsAPI, errMsg } from '../lib/regulatoryAPI';

export default function Bulletins() {
  const [meta, setMeta] = useState(null);
  const [tab, setTab] = useState(() => new URLSearchParams(window.location.search).get('tab') || 'radar');
  const loadMeta = useCallback(() => bulletinsAPI.meta().then(setMeta).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { loadMeta(); }, [loadMeta]);
  return (
    <div className="mx-auto max-w-6xl space-y-6 p-6" data-testid="bulletins-page">
      <div>
        <h1 className="text-3xl font-bold text-foreground" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Bulletins</h1>
        <p className="mt-1 text-muted-foreground">Regulatory radar – ATO, TPB and professional body updates, key dates and follow-ups.</p>
      </div>
      {meta && <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="radar" data-testid="bulletins-tab-radar"><Radar className="mr-2 h-4 w-4" />Regulatory Radar</TabsTrigger>
          <TabsTrigger value="content" data-testid="bulletins-tab-content"><PenSquare className="mr-2 h-4 w-4" />Content Hub</TabsTrigger>
          {meta.can_manage && <TabsTrigger value="settings" data-testid="bulletins-tab-settings"><Settings2 className="mr-2 h-4 w-4" />Settings</TabsTrigger>}
        </TabsList>
        <TabsContent value="radar"><BulletinDashboard meta={meta} /></TabsContent>
        <TabsContent value="content"><ContentHub meta={meta} /></TabsContent>
        {meta.can_manage && <TabsContent value="settings"><BulletinSettings onSaved={loadMeta} /></TabsContent>}
      </Tabs>}
    </div>
  );
}
